import styled from 'styled-components'
import breakpoints from '../../../styles/breakpoints'
import StatusMessage from './status-message'

const FormActions = styled.section`
  display: grid;
  grid-template-areas:
    'status'
    'button';
  grid-template-columns: 1fr;
  grid-template-rows: auto auto;
  gap: ${props => props.theme.spacing.base400};

  align-items: center;
  margin-top: ${props => props.theme.spacing.base500};

  @media (min-width: ${breakpoints.sm}) {
    grid-template-areas: 'status button';
    grid-template-columns: 1fr auto;
    grid-template-rows: 1fr;
  }

  ${StatusMessage} {
    grid-area: status;
  }

  button[type='submit'] {
    width: auto;
    font-weight: bold;
    padding: ${props => props.theme.spacing.base400} ${props => props.theme.spacing.base600};
    grid-area: button;
  }
`

export default FormActions
